"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFINED = exports.LOG_PREFIX = void 0;
exports.LOG_PREFIX = 'storage:localstorage: ';
exports.DEFINED = '1';
